export default __webpack_public_path__ + "static/media/HospitalConfig.06703381.svg";